import React from 'react'
import "./GridGallery.css";

const GridGallery = (props) => {
    return (
            <div className={"container"}>
                <div className={"vertical_img"} >
                    <img src={props.props.VerticalImage} /> 
                    <div className={"overlay"}></div>
                </div>
                <div className={"horizontal_img"} >
                    <img src={props.props.HorizontalImage} /> 
                    <div className={"overlay"}></div>
                </div>
                <div className={"box_img1"} > 
                    <img src={props.props.LeftBox} /> 
                    <div className={"overlay"}></div>
                </div>
                <div className={"box_img2"} > 
                    <img src={props.props.RightBox} /> 
                    <div className={"overlay"}></div>
                </div>
                <div className={"horizontal_img2"} > 
                    <img src={props.props.BottomImage} /> 
                    <div className={"overlay"}></div>
                </div>
                <div className={"show_more"}>
                    <a className={"show_more_btn"} href="/#/portfolio"> Show More </a>
                </div>
            </div>
    )
}

export default GridGallery
